import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUkraine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1538)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#FFDA44"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
			fill: "#338AF3"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1538",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgUkraine;
